import PrimaryButton from 'components/button/PrimaryButton';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import { theme } from 'utils/style/theme';
import styled from 'styled-components';
import React, { useContext, useEffect, useState } from 'react';
import {
  ICommonCode,
  IEpisodesDetail,
  ISupportLanguage,
} from 'utils/types/storyTypes';
import { useTranslation } from 'react-i18next';
import DefaultInput from 'components/input/DefaultInput';
import InputWrappingBox from 'components/container/InputWrappingBox';
import { Checkbox, message, Radio, Select } from 'antd';
import { handleMessage } from 'utils/helper/message';
import { useNavigate } from 'react-router-dom';
import { episodeApi } from 'apis/story/episodeApis';
import { useCookies } from 'react-cookie';
import UploadEpisodeThumbnail from './UploadEpisodeThumbnail';
import UnlockStyleSelect from '../UnlockStyleSelect';
import SelectBox from 'components/SelectBox';
import refreshPage from 'utils/helper/refreshPage';
import LocalizingContext from '../../../../../context/LocalizingContext';

interface IProps {
  data: IEpisodesDetail | null;
  setData: React.Dispatch<React.SetStateAction<IEpisodesDetail | null>>;
}

const FormRightContent: React.FC<IProps> = ({ data, setData }) => {
  const [cookies] = useCookies(['lang']);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [connectEpisodeList, setConnectEpisodeList] = useState<
    ICommonCode[] | null
  >(null);

  const [charactersList, setCharactersList] = useState<ICommonCode[] | null>(
    null,
  );

  const [endingStatus, setEndingStatus] = useState<ICommonCode[] | null>(null);
  const [couponList, setCouponList] = useState<ICommonCode[] | null>(null);

  const [endingType, setEndingType] = useState<string | undefined>(
    data?.ending_type,
  );
  const [unlockCondition, setUnlockCondition] = useState<ICommonCode[] | null>(
    null,
  );

  const handleGetCharactersList = async () => {
    if (data) {
      const connectEpisodeData = await episodeApi.charactersList(
        data.project_id.toString(),
        data.dlc_id.toString(),
      );
      setCharactersList(connectEpisodeData);
    }
  };

  const handleGetEpisodeList = async () => {
    if (data) {
      const connectEpisodeData = await episodeApi.connectEpisodeList(
        data.project_id.toString(),
        data.dlc_id.toString(),
      );
      setConnectEpisodeList(connectEpisodeData);
    }
  };

  const handleGetCouponList = async () => {
    if (data) {
      const couponListData = await episodeApi.couponList(
        data.project_id.toString(),
        data.dlc_id.toString(),
      );
      setCouponList(couponListData);
    }
  };

  const hanldeGetEndingStatus = async () => {
    const endingStatusData = await episodeApi.episodeStatus(cookies.lang);
    setEndingStatus(endingStatusData);
  };
  const hanldeGetUnlockCondition = async () => {
    const endingStatusData = await episodeApi.unlockCondition(cookies.lang);
    setUnlockCondition(endingStatusData);
  };

  useEffect(() => {
    hanldeGetEndingStatus();
    hanldeGetUnlockCondition();
  }, [cookies]);

  useEffect(() => {
    handleGetEpisodeList();
    handleGetCharactersList();
    handleGetCouponList();
    setEndingType(data?.ending_type);
  }, [data]);

  const handleSubmit = async () => {
    if (!data) {
      handleMessage(message, 'error', 'there is no data');
      return;
    }

    if (data.title.length === 0) {
      handleMessage(message, 'error', 'Please enter title');
      return;
    }

    try {
      await episodeApi.updateEpisodeDetail(
        cookies.lang,
        data.project_id.toString(),
        data,
      );

      handleMessage(message, 'success', 'Success');
      refreshPage();
    } catch (err) {
      handleMessage(message, 'error', 'Please try again');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleOnChangeSelect = (value, type: string) => {
    if (data) {
      if (type === 'unlock_style') {
        const cloneData = JSON.parse(JSON.stringify(data));
        cloneData[type] = value;
        cloneData['unlock_by'] = null;
        setData(cloneData);
      } else {
        const cloneData = JSON.parse(JSON.stringify(data));
        cloneData[type] = value;
        setData(cloneData);
      }
    }
  };

  const handleOnChangeInput = (e: { target: HTMLInputElement }) => {
    if (data) {
      const cloneData = JSON.parse(JSON.stringify(data));
      cloneData.title = e.target.value;
      setData(cloneData);
    }
  };

  return (
    <>
      <InputWrappingBox>
        <Wrapper>
          <SectionWarpper>
            <div className='header'>
              <p>
                Episode ID: <span>{data?.episode_id}</span>
              </p>
              <p>Episode type: {data?.episode_type}</p>
              <div className='fixed'>
                <p>Fixed Script: </p>{' '}
                <CheckboxWrapper checked={false} disabled />
              </div>
            </div>
            {/* add Input episode title for update*/}
            <div>
              {/*<p className="title">*/}
              {/*  {t('updateEpisode.rightForm.title')}*/}
              {/*</p>*/}
              <DefaultInput
                title={t('updateEpisode.rightForm.title')}
                name='title'
                maxLength={60}
                value={data?.title}
                onChange={handleOnChangeInput}
                noMarginBottom
              />
            </div>
            <div>
              <p className='title'>
                {t('updateEpisode.rightForm.connectedEpisode')}
              </p>
              <SelectBox
                value={data?.depend_episode}
                onChange={(e) => {
                  handleOnChangeSelect(e, 'depend_episode');
                }}
                options={connectEpisodeList?.map((v, i) => {
                  return {
                    value: v.code,
                    label: v.code_name,
                  };
                })}
              />
            </div>
            <div>
              <p className='title'>{t('updateEpisode.rightForm.endingType')}</p>
              <Radio.Group
                onChange={(e) => {
                  setEndingType(e.target.value);
                  handleOnChangeSelect(e.target.value, 'ending_type');
                }}
                value={endingType}
              >
                <Radio value='final'>Final</Radio>
                <Radio value='hidden'>Hidden</Radio>
              </Radio.Group>
            </div>
            <div>
              <p className='title'>
                {t('updateEpisode.rightForm.episodeStatus')}
              </p>
              <SelectBox
                value={data?.episode_status}
                onChange={(e) => {
                  handleOnChangeSelect(e, 'episode_status');
                }}
                options={endingStatus?.map((v, i) => {
                  return {
                    value: v.code,
                    label: v.code_name,
                  };
                })}
              />
            </div>
            <div>
              <p className='title'>{t('updateEpisode.rightForm.character')}</p>
              <SelectBox
                value={data?.speaker}
                onChange={(e) => {
                  handleOnChangeSelect(e, 'speaker');
                }}
                options={charactersList?.map((v, i) => {
                  return {
                    value: v.code,
                    label: v.code_name,
                  };
                })}
              />
            </div>
            <div>
              <p className='title'>
                {t('updateEpisode.rightForm.unlockCondition')}
              </p>
              <div className='condition'>
                <SelectBox
                  value={data?.unlock_style}
                  onChange={(e) => {
                    handleOnChangeSelect(e, 'unlock_style');
                  }}
                  options={unlockCondition?.map((v, i) => {
                    return {
                      value: v.code,
                      label: v.code_name,
                    };
                  })}
                />
                {data?.unlock_style === 'episode' ? (
                  <UnlockStyleSelect
                    data={connectEpisodeList}
                    value={data?.unlock_by}
                    handleOnChangeSelect={handleOnChangeSelect}
                  />
                ) : data?.unlock_style === 'coupon' ? (
                  <UnlockStyleSelect
                    data={couponList}
                    value={data?.unlock_by}
                    handleOnChangeSelect={handleOnChangeSelect}
                  />
                ) : data?.unlock_style === 'scene' ? (
                  <DefaultInput
                    title=''
                    name='title'
                    value={data?.unlock_by}
                    onChange={(e) => {
                      handleOnChangeSelect(Number(e.target.value), 'unlock_by');
                    }}
                    allowClear={true}
                    noMarginBottom
                    maxLength={50}
                    type='number'
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div>
              <p className='title'>{t('updateEpisode.rightForm.thumbnail')}</p>
              <UploadEpisodeThumbnail data={data} setData={setData} />
            </div>
          </SectionWarpper>
        </Wrapper>
      </InputWrappingBox>
      <SubmitFlexBox style={{ columnGap: 12, marginTop: '24px' }}>
        <>
          <PrimaryButton
            text={t('updateStory.form.buttonCancel')}
            height='40px'
            width='151px'
            bgColor='#FFFF'
            textColor={theme.colors.dark_400}
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.gray_6}`}
            rounded='6px'
            hoverBgColor={'#FFFF'}
            activeBgColor={'#FFFF'}
            selectedBgColor={'#FFFF'}
            onClick={handleCancel}
          />
          <PrimaryButton
            text={t('updateStory.form.buttonSubmit')}
            height='40px'
            width='151px'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
          />
        </>
      </SubmitFlexBox>
    </>
  );
};

export default FormRightContent;

const Wrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .title {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header p {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
  }
  .header p span {
    font-weight: ${theme.fontWeights.bold};
  }
  .fixed {
    display: flex;
    align-items: center;
    justify-content: center;
    & > * + * {
      margin-left: 10px;
    }
  }
  .condition {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > * + * {
      margin-left: 16px;
    }
  }
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 24px;
  }
  .ant-input-disabled {
    color: ${theme.colors.dark_300};
  }
`;

const CheckboxWrapper = styled(Checkbox)`
  .ant-checkbox .ant-checkbox-input {
    cursor: default;
  }
  .ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
    border: 1px solid #d9d9d9;
  }
`;
